var map = {
	"./0iconmonstr-paintbrush-7.svg": 3779,
	"./1com-blue-icon.png": 244,
	"./2com-red-icon.png": 7765,
	"./3com-green-icon.png": 8821,
	"./4com-gold-icon.png": 3752,
	"./5com-gray-icon.png": 2336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5454;